module.exports = __webpack_public_path__ + "img/logo@2x.2f7b0f9f.png";